<template>
  <div class="product-box-wide__segment-center">
    <div
      v-if="highlightBadgeData"
      class="product-box-wide__highlight-article-badge"
    >
      <div
        v-if="highlightBadgeData.text"
        v-html="highlightBadgeData.text"
        class="product-box-wide__highlight-article-text"
      />
      <img
        v-if="highlightBadgeData.icon"
        class="product-box-wide__highlight-article-icon"
        :src="highlightBadgeData.icon"
        alt=""
        aria-hidden="true"
      >
    </div>
    <a
      class="product-box-wide__header product-box__segment-header"
      :href="productBoxData.url"
    >
      <div class="product-box-wide__header-text product-box__header-text">
        <span
          v-if="productBoxData.vintage"
          class="product-box-wide__vintage product-box__vintage"
        >
          {{ productBoxData.vintage }}
        </span>
        <span class="product-box-wide__name product-box__name">
          {{ productBoxData.description1 }}
        </span>
        <span
          v-if="productBoxData.description2"
          class="product-box-wide__sub-name product-box__name"
        >
          {{ productBoxData.description2 }}
        </span>
        <span
          v-if="productBoxData.description3"
          class="product-box-wide__sub-name product-box__name"
        >
          {{ productBoxData.description3 }}
        </span>
        <span
          class="product-box-wide__short-description product-box__short-description"
          v-if="productBoxData.shortDescription"
          v-html="productBoxData.shortDescription"
        />
      </div>
    </a>
    <div
      class="product-box-wide__long-description"
      v-html="descriptionExcerpt"
    />
  </div>
</template>
<script setup lang="ts">
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';
  import {computed} from 'vue';
  import {t} from '@/bps/utilities/js/translations/translations';

  const props = defineProps<{
    descriptionExcerpt: String;
    minimumRating: String;
    basketUrl: String;
    productBoxData: ProductBoxData;
  }>();

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

  const highlightBadgeData = computed(() => {
    const textSpacer = '&nbsp;&nbsp;';

    if (highlightArticleData.value) {
      const articleHighlight = highlightArticleData.value;
      articleHighlight.text += textSpacer;
      return articleHighlight;
    }

    if (props.productBoxData.personalPreferenceMessageKey) {
      return {
        style: {},
        text: t(props.productBoxData.personalPreferenceMessageKey) + textSpacer,
        icon: null
      };
    }

    return null;
  });
</script>
